import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeSecondCenterModal } from "store/slices/SecondCenterModal.slice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const SecondCenterModal = () => {
  const {
    isOpen,
    actions,
    content,
    fullScreen,
    maxWidth = "465px",
  } = useSelector((state) => state.secondCenterModal);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(closeSecondCenterModal());
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={fullScreen}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: { maxWidth },
          bgcolor: "background.gray400",
          backgroundImage: "none",
          boxShadow: "none",
          padding: "4px",
          borderRadius: "12px",
          margin: { sm: "20px" },
        },
      }}
      TransitionComponent={Transition}
      className="centerModel"
    >
      <DialogContent className="no-scrollbar" sx={{ p: "0" }}>
        {content}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default SecondCenterModal;
